import type { ReactNode } from 'react'

interface PortfolioMobileActionsFooterProps {
  children: ReactNode
}

export function PortfolioMobileActionsFooter({ children }: PortfolioMobileActionsFooterProps) {
  return (
    <div className="sm:hidden px-3 pb-3 pt-3 bg-[#222f42]">
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  )
}
